function richTextOf(segment) {
  const content = segment.segment_content ?? {};
  return content.data ?? content;
}

function withRichText(segment, richText) {
  const content = segment.segment_content ?? {};
  return { ...segment, segment_content: content.data ? { ...content, data: richText } : { ...content, ...richText } };
}

const mentionsIn = segment => segment.segment_type === "rich_text" && (richTextOf(segment).ranges ?? []).some(range => range.style === "AT_SYMBOL");

export function markOwnMentions(segments, myUserId) {
  if (!segments.some(mentionsIn)) {
    return segments;
  }
  return segments.map(segment => {
    if (!mentionsIn(segment)) {
      return segment;
    }
    const richText = richTextOf(segment);
    const ranges = richText.ranges.map(range => {
      if (range.style !== "AT_SYMBOL") {
        return range;
      }
      return { ...range, isMe: Number.parseInt(range.entityId) === myUserId };
    });
    return withRichText(segment, { ...richText, ranges });
  });
}
